up.compiler('form', (form) => {
  function hideNestedRowsForDestruction(_evnt, destroyButton) {
    if (confirm('Diesen Eintrag löschen?')) {
      const row = destroyButton.closest('tr')
      const input = row.querySelector('input.destruction-marker')

      input.value = '1'
      up.emit(input, 'change')
      up.element.hide(row)
    }
  }

  // disable all forms while submitting
  form.setAttribute('up-disable', '')

  up.on(form, 'click', '.destruction-icon', hideNestedRowsForDestruction)
})
